/**
 * card-social-proof.js
 * Fills the review line on product cards ("★ 4.8 (23)") from the Quoli reviews API.
 * - Only products with at least 1 review show anything (no "0 reviews").
 * - Works for cards added later by "Load more"/infinite scroll (MutationObserver).
 * - Looks up each product once per 10 minutes (sessionStorage) and only when the card is near the viewport.
 */
(function () {
  "use strict";
  var API = "/apps/quoli/v1/public/products/";
  var TTL = 10 * 60 * 1000;
  var STAR = '<svg class="card-rating__star" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1.6l3.1 6.6 7.2.9-5.3 5 1.4 7.2L12 17.7 5.6 21.3 7 14.1 1.7 9.1l7.2-.9z"/></svg>';

  function cacheGet(id) {
    try {
      var v = JSON.parse(sessionStorage.getItem("hom_rt_" + id) || "null");
      if (v && Date.now() - v.t < TTL) return v;
    } catch (e) {}
    return null;
  }
  function cacheSet(id, data) {
    try { sessionStorage.setItem("hom_rt_" + id, JSON.stringify({ t: Date.now(), a: data.average, c: data.count })); } catch (e) {}
  }
  function render(el, avg, count) {
    if (!(count >= 1) || !(avg > 0)) { el.classList.remove("is-ready"); el.innerHTML = ""; return; }
    el.innerHTML = STAR + '<span class="card-rating__avg">' + (Math.round(avg * 10) / 10).toFixed(1) +
      '</span><span class="card-rating__count">(' + count + ")</span>";
    el.setAttribute("aria-label", "Rated " + avg.toFixed(1) + " out of 5 from " + count + " reviews");
    el.classList.add("is-ready");
  }
  function load(el) {
    if (el.dataset.loaded) return;
    el.dataset.loaded = "1";
    var id = el.getAttribute("data-product-id");
    var cached = cacheGet(id);
    if (cached) return render(el, cached.a, cached.c);
    fetch(API + id + "/rating?merchantId=" + encodeURIComponent(el.getAttribute("data-merchant") || ""), { headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("http"); return r.json(); })
      .then(function (d) {
        var avg = Number(d.average), cnt = Number(d.count);
        cacheSet(id, { average: avg, count: cnt });
        render(el, avg, cnt);
      })
      .catch(function () { /* app unreachable: show nothing */ });
  }

  var io = ("IntersectionObserver" in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); load(e.target); } });
  }, { rootMargin: "300px 0px" }) : null;

  function scan(root) {
    (root || document).querySelectorAll("[data-card-rating]:not([data-loaded])").forEach(function (el) {
      if (io) io.observe(el); else load(el);
    });
  }
  function boot() {
    scan(document);
    if ("MutationObserver" in window) {
      new MutationObserver(function (m) {
        for (var i = 0; i < m.length; i++) { if (m[i].addedNodes && m[i].addedNodes.length) { scan(document); break; } }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
